import { Heart, Check } from 'lucide-react';
import { cn } from '../../lib/utils';
import { INTERESTS } from './tripConstants';

export const InterestsStep = ({ formData, toggleArrayItem }) => (
  <div className="space-y-6">
    <div className="flex items-center gap-3 mb-6">
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-gold to-sky flex items-center justify-center text-white shadow-lg">
        <Heart className="w-6 h-6" />
      </div>
      <div>
        <h3 className="text-xl font-semibold text-ocean">What are you interested in?</h3>
        <p className="text-ocean/70 text-sm">Select all that excite you</p>
      </div>
    </div>
    <div className="flex flex-wrap gap-3">
      {INTERESTS.map((interest) => (
        <button key={interest.value}
          onClick={() => toggleArrayItem('interests', interest.value)}
          className={cn('inline-flex items-center gap-2 px-5 py-3 rounded-full border-2 transition-all duration-300',
            formData.interests.includes(interest.value)
              ? 'border-ocean bg-gradient-to-r from-ocean to-sky text-white shadow-lg scale-105'
              : 'border-ocean/20 bg-white/50 hover:border-ocean/50 hover:shadow-md text-ocean backdrop-blur-sm')}
          data-testid={`interest-${interest.value}`}>
          {interest.label}
          {formData.interests.includes(interest.value) && <Check className="w-4 h-4 ml-1" />}
        </button>
      ))}
    </div>
  </div>
);
